import React, { useState, useEffect, useRef } from 'react';
import T from 'prop-types';
import cx from 'classnames';

const ExpandableRow = ({ show, children, rootCellColSpan, transitionTimeout = 300 }) => {
  const expandableContainerRef = useRef();
  const [isMounted, setMounted] = useState(show);

  const showChildren = show || isMounted;

  useEffect(() => {
    if (show) setMounted(show);
  }, [show]);

  // Unmount children on exit
  useEffect(() => {
    let timeoutId;

    if (!show && isMounted) {
      timeoutId = setTimeout(() => {
        setMounted(false);
      }, transitionTimeout);
    }

    return () => clearTimeout(timeoutId);
  }, [show]);

  const getContainerHeight = () => {
    if (show && expandableContainerRef.current) {
      return expandableContainerRef.current.scrollHeight;
    }

    return 0;
  };

  return (
    <tr className={cx('expandable-root-row', { expanded: show })}>
      <td colSpan={rootCellColSpan} className="expandable-root-cell">
        <div
          ref={expandableContainerRef}
          className="expandable-container"
          style={{ height: getContainerHeight() }}
        >
          {showChildren ? children : null}
        </div>
      </td>
    </tr>
  );
};

ExpandableRow.propTypes = {
  show: T.bool.isRequired,
  children: T.node.isRequired,
  rootCellColSpan: T.number.isRequired,
  transitionTimeout: T.number,
};

export default ExpandableRow;
